/**
 * This files contains all the images that can we be used across the app
 */
import { solutionSetStatus } from './SolutionSetStatus';

import CALENDAR_LOGO from '../assets/img/calendar.svg';
import DOSELECT_BAD_BOT_LOGO from '../assets/img/bad-bot.svg';
import DOSELECT_DARK_LOGO from '../assets/img/doselect-logo-inverted.svg';
import DOSELECT_FEEDBACK_BOT_LOGO from '../assets/img/mascot-feedback-thumbsup.svg';
import DOSELECT_LOGO from '../assets/img/doselect-logo-white.svg';
import DOSELECT_MARK_LOGO from '../assets/img/doselect-mark.svg';
import NOT_QUALIFIED_LOGO from '../assets/img/not-qualified.svg';
import OUTSTANDING_LOGO from '../assets/img/outstanding.svg';
import PROBLEM_SET_LOGO from '../assets/img/problemset.svg';
import PROBLEM_UNSOLVED_LOGO from '../assets/img/unsolved.svg';
import PROBLEMS_LOGO from '../assets/img/problems.svg';
import PROCTOR_ILLUSTRATION from '../assets/img/proctor_illustration.svg';
import QUALIFIED_LOGO from '../assets/img/qualified.svg';
import QUALITY_BAD_LOGO from '../assets/img/quality-bad.svg';
import QUALITY_GOOD_LOGO from '../assets/img/quality-good.svg';
import QUALITY_OK_LOGO from '../assets/img/quality-ok.svg';
import SCORE_LOGO from '../assets/img/score.svg';
import SOLUTION_ACCEPTED_LOGO from '../assets/img/solution-acc.svg';
import SOLUTION_NEEDS_REVIEW_LOGO from '../assets/img/solution-nre.svg';
import SOLUTION_PARTIALLY_CORRECT_LOGO from '../assets/img/solution-pac.svg';
import SOLUTION_REJECTED_LOGO from '../assets/img/solution-rej.svg';
import SOLUTION_UNEVALUATED_LOGO from '../assets/img/solution-une.svg';
import SOLUTIONSET_COMPLETED from '../assets/img/solutionset_completed.svg';
import SOLUTIONSET_FAILED from '../assets/img/solutionset_failed.svg';
import SOLUTIONSET_NEEDS_REVIEW from '../assets/img/solutionset_needs_review.svg';
import SOLUTIONSET_PASSED from '../assets/img/solutionset_passed.svg';
import TIMER_LOGO from '../assets/img/timer.svg';
import WEBCAM_NOT_FOUND from '../assets/img/proctor-webcam-flagged.svg';
import MIC_NOT_FOUND from '../assets/img/micNotFound.svg';
import PDF_ICON from '../assets/img/pdf-icon.svg';
import CLOUD_UPLOAD from '../assets/img/cloud-uploadv2.svg';
import CROSS_BORDER from '../assets/img/cross-border.svg';
import STOP_WATCH from '../assets/img/stopwatch.svg';
import STOP_WATCH_RED from '../assets/img/stopwatch_red.svg';
import LOADER from '../assets/img/loader.svg';
import CHECK_CIRCLE from '../assets/img/check-circle.svg';
import PAUSE_ICON from '../assets/img/pause_icon.svg';
import PLAY_ICON from '../assets/img/play_icon.svg';
import POWERED_BY_DOSELECT from '../assets/img/powered-by-doselect.svg';
import NOT_SUPPORTED_ICON from '../assets/img/not_supported_icon.svg';

const IMAGES = {
  CALENDAR_LOGO,
  DOSELECT_BAD_BOT_LOGO,
  DOSELECT_DARK_LOGO,
  DOSELECT_FEEDBACK_BOT_LOGO,
  DOSELECT_LOGO,
  DOSELECT_MARK_LOGO,
  NOT_QUALIFIED_LOGO,
  OUTSTANDING_LOGO,
  PROBLEM_SET_LOGO,
  PROBLEM_UNSOLVED_LOGO,
  PROBLEMS_LOGO,
  PROCTOR_ILLUSTRATION,
  QUALIFIED_LOGO,
  QUALITY_BAD_LOGO,
  QUALITY_GOOD_LOGO,
  QUALITY_OK_LOGO,
  SCORE_LOGO,
  SOLUTION_ACCEPTED_LOGO,
  SOLUTION_NEEDS_REVIEW_LOGO,
  SOLUTION_PARTIALLY_CORRECT_LOGO,
  SOLUTION_REJECTED_LOGO,
  SOLUTION_UNEVALUATED_LOGO,
  TIMER_LOGO,
  WEBCAM_NOT_FOUND,
  MIC_NOT_FOUND,
  PDF_ICON,
  CLOUD_UPLOAD,
  CROSS_BORDER,
  STOP_WATCH,
  STOP_WATCH_RED,
  LOADER,
  CHECK_CIRCLE,
  PAUSE_ICON,
  PLAY_ICON,
  POWERED_BY_DOSELECT,
  NOT_SUPPORTED_ICON,
};

export const SOLUTIONSET_STATUS_ICONS = {
  [solutionSetStatus.CMP]: SOLUTIONSET_COMPLETED,
  [solutionSetStatus.FAL]: SOLUTIONSET_FAILED,
  [solutionSetStatus.NRE]: SOLUTIONSET_NEEDS_REVIEW,
  [solutionSetStatus.PAS]: SOLUTIONSET_PASSED,
};

export default IMAGES;
